import React  from 'react'


const Timeline = () => {

    return <div className='timeline-widgets-container'><livelike-widgets className="timeline-widgets" programid="37b2ee75-b1b4-4cc9-9eb0-d268efc7427d"
                             mode="timeline">
    </livelike-widgets></div>
}

export default Timeline;